import { LinkPrimaryArrow } from "components/link/Link";
import OverlayLoader from "components/loader/OverlayLoader";
import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import config from "config/config";
import { UploadedDocument } from "models/dashboard/dashboard";
import UploadedDocumentsPreviewItem from "../uploadedDocumentsPreviewItem/UploadedDocumentsPreviewItem";

import { useRequiredCustomerId } from "hooks/use-customer-id";
import "./UploadedDocumentsPreview.scss";

type Props = {
  uploadedDocuments: UploadedDocument[];
  isLoading: boolean;
};

export default function UploadedDocumentsPreview({
  uploadedDocuments,
  isLoading
}: Props) {
  const customerId = useRequiredCustomerId();
  return (
    <section aria-label="Nya inleveranser" className="documentPreview">
      <h1 className="m-0 d-flex align-items-center">
        Nya inleveranser
        <InfoIconTooltip className="ml-3">
          Här visas de fem senaste inleveranserna som inte har blivit hanterade.
          När du klickar på inlevererat dokument kommer du in till fliken
          Inleveranser där du kan hantera inleveransen. När du har fått en ny
          inleverans från kunden visas det här.
        </InfoIconTooltip>
      </h1>
      <hr className="header-border" />

      <OverlayLoader isLoading={isLoading}>
        <>
          <ul className="p-0">
            {uploadedDocuments.map((document) => {
              const link = config.internalRoutes.delivery(customerId);
              return (
                <UploadedDocumentsPreviewItem
                  key={document.id}
                  document={document}
                  link={link}
                />
              );
            })}
          </ul>
          {uploadedDocuments.length === 0 && <p>Inga nya inleveranser</p>}
        </>
      </OverlayLoader>

      <hr className="footer-border" />
      <LinkPrimaryArrow
        to={`${config.internalRoutes.delivery(customerId)}`}
      >
        Till inleveranser
      </LinkPrimaryArrow>
    </section>
  );
}
